import { cn } from "@/lib/utils";
import { SECTIONS, type SettingsSection } from "./types";

export function SettingsNav({
  activeSection,
  onSection,
}: {
  activeSection: SettingsSection;
  onSection: (section: SettingsSection) => void;
}) {
  return (
    <aside className="lg:sticky lg:top-4 lg:self-start">
      <nav
        aria-label="Sekcije postavki"
        className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-2 [scrollbar-width:none] lg:mx-0 lg:flex lg:flex-col lg:gap-0.5 lg:overflow-visible lg:rounded-2xl lg:border lg:border-border/60 lg:bg-card lg:p-2 lg:shadow-sm [&::-webkit-scrollbar]:hidden"
      >
        {SECTIONS.map((item) => {
          const active = activeSection === item.key;
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onSection(item.key)}
              aria-current={active ? "page" : undefined}
              className={cn(
                "group relative flex min-w-fit items-center gap-3 rounded-xl px-2.5 py-2.5 text-left transition-colors lg:w-full",
                active
                  ? "bg-[oklch(94.43%_0.017_186.62)] text-foreground"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground",
              )}
            >
              {active && (
                <span
                  aria-hidden
                  className="absolute inset-y-2 left-0 hidden w-[3px] rounded-full bg-primary lg:block"
                />
              )}
              <span
                className={cn(
                  "grid size-8 shrink-0 place-items-center rounded-lg border transition-colors",
                  active
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-border/60 bg-background text-muted-foreground group-hover:text-primary",
                )}
              >
                <Icon className="size-4" weight={active ? "duotone" : "regular"} />
              </span>
              <span className="min-w-0">
                <span className="block whitespace-nowrap text-sm font-semibold">{item.label}</span>
                <span className="hidden truncate text-[11px] text-muted-foreground lg:block">{item.description}</span>
              </span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
